'use strict';
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/lmds-react-field/node_modules/core-js/internals/object-get-own-property-symbols.js
// module id = 802
// module chunks = 0